import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SMART_CARD_KEYS, SMART_CARD_LABELS } from "@/lib/smartCards";

// Lot 554 — Admin › Paramètres › Cartes intelligentes : membres distincts ayant vu / ouvert / masqué chaque carte.
export const SmartCardsStats = () => {
  const [days, setDays] = useState(7);
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let alive = true;
    setData(null); setError(false);
    api.get(`/admin/smart-cards/stats?days=${days}`)
      .then(({ data: d }) => { if (alive) setData(d); })
      .catch(() => { if (alive) setError(true); });
    return () => { alive = false; };
  }, [days]);
  const rows = data?.cards || SMART_CARD_KEYS.map((key) => ({ key, seen: null, opened: null, dismissed: null, dismiss_rate: null }));
  const muted = { color: "var(--yalola-text-muted)" };
  const rateColor = (r) => (r == null ? muted.color : r >= 50 ? "#b91c1c" : r >= 25 ? "#b45309" : "var(--yalola-secondary)");
  return (
    <div className="mt-4 pt-4 border-t" style={{ borderColor: "var(--yalola-border)" }} data-testid="smart-cards-stats">
      <div className="flex items-center justify-between gap-3 mb-2">
        <div>
          <div className="text-sm font-medium">Statistiques des cartes</div>
          <div className="text-[11px]" style={muted}>Membres distincts ayant vu (60 % à l'écran), ouvert (tap dans la carte) ou masqué (×) chaque carte. Un taux de masquage élevé = carte à repenser ou à rétrograder.</div>
        </div>
        <div className="flex gap-1 shrink-0" data-testid="smart-cards-stats-period">
          {[7, 30].map((d) => (
            <button key={d} type="button" onClick={() => setDays(d)} className={`pill !text-[12px] !px-3 !py-1 ${days === d ? "pill-primary" : "pill-outline"}`} data-testid={`smart-cards-stats-${d}d`}>{d} j</button>
          ))}
        </div>
      </div>
      {error && <div className="text-xs text-red-600" data-testid="smart-cards-stats-error">Statistiques indisponibles pour le moment.</div>}
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="smart-cards-stats-table">
          <thead>
            <tr className="text-[11px] uppercase tracking-wide text-left" style={muted}>
              <th className="py-1.5 pr-2 font-semibold">Carte</th><th className="py-1.5 px-2 font-semibold text-right">Vue par</th>
              <th className="py-1.5 px-2 font-semibold text-right">Ouverte par</th><th className="py-1.5 px-2 font-semibold text-right">Masquée par</th>
              <th className="py-1.5 pl-2 font-semibold text-right">Taux de masquage</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.key} className="border-t" style={{ borderColor: "var(--yalola-border)" }} data-testid={`smart-cards-stats-row-${r.key}`}>
                <td className="py-2 pr-2 font-medium">{SMART_CARD_LABELS[r.key] || r.key}</td>
                <td className="py-2 px-2 text-right tabular-nums" data-testid={`smart-cards-stats-seen-${r.key}`}>{r.seen ?? "…"}</td>
                <td className="py-2 px-2 text-right tabular-nums" data-testid={`smart-cards-stats-opened-${r.key}`}>{r.opened ?? "…"}</td>
                <td className="py-2 px-2 text-right tabular-nums" data-testid={`smart-cards-stats-dismissed-${r.key}`}>{r.dismissed ?? "…"}</td>
                <td className="py-2 pl-2 text-right tabular-nums font-semibold" style={{ color: rateColor(r.dismiss_rate) }} data-testid={`smart-cards-stats-rate-${r.key}`}>{r.dismiss_rate == null ? "…" : `${r.dismiss_rate} %`}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
